import React from 'react'
import { CircularProgress } from '@material-ui/core'

export default function Loading(): JSX.Element {
  return (
    <div style={{ position: 'fixed', top: '50%', left: '45%' }}>
      <CircularProgress />
    </div>
  )
}
